
import { Component } from "vue-property-decorator"
import BaseInput from "~/core/BaseInput"

const ADJECTIVES = [
  "swift",
  "bright",
  "lucky",
  "silent",
  "golden",
  "wild",
  "clever",
  "brave",
  "crisp",
  "nova",
  "solar",
  "rapid",
  "bouncy",
  "cheeky",
  "chunky",
  "cosmic",
  "dizzy",
  "fancy",
  "fluffy",
  "goofy",
  "jolly",
  "loopy",
  "mellow",
  "mischief",
  "noisy",
  "peppy",
  "puffy",
  "quirky",
  "sassy",
  "snappy",
  "sparkly",
  "spicy",
  "squishy",
  "wacky",
  "wiggly",
  "zesty",
]

const NOUNS = [
  "river",
  "forest",
  "stone",
  "cloud",
  "falcon",
  "ember",
  "meadow",
  "wave",
  "comet",
  "summit",
  "breeze",
  "harbor",
  "banana",
  "biscuit",
  "bubble",
  "cactus",
  "cupcake",
  "dolphin",
  "dumpling",
  "eggroll",
  "ferret",
  "flipflop",
  "fritter",
  "goblin",
  "koala",
  "llama",
  "marshmallow",
  "meatball",
  "muffin",
  "nacho",
  "noodle",
  "otter",
  "pancake",
  "pickle",
  "pigeon",
  "pumpkin",
  "raccoon",
  "sausage",
  "scooter",
  "slipper",
  "taco",
  "teapot",
  "waffle",
  "walrus",
]

const FUNNY_PREFIXES = [
  "captain",
  "chaos",
  "disco",
  "drama",
  "jazz",
  "mega",
  "mystery",
  "party",
  "pixel",
  "rocket",
  "sir",
  "turbo",
]

@Component
export default class RandomWordField extends BaseInput {
  generateRandomWord() {
    const prefix =
      FUNNY_PREFIXES[Math.floor(Math.random() * FUNNY_PREFIXES.length)]
    const adjective =
      ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)]
    const noun = NOUNS[Math.floor(Math.random() * NOUNS.length)]
    const suffix = Math.floor(100 + Math.random() * 900)
    const randomWord = `${prefix}-${adjective}-${noun}-${suffix}`

    this.onInput(randomWord)
  }
}
